import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Particle from "../Particle";

function TermsOfUse() {
  return (
    <Container fluid className="about-section policy-page">
      <Particle />
      <Container className="policy-container">
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <header className="policy-header">
              <h1 className="policy-title">
                <span className="purple">Terms of Use</span>
              </h1>
              <p className="policy-lead">Choicest Fruit®, LLC</p>
              <p className="policy-lead">Effective Date: April 23, 2026</p>
              <p className="policy-lead">Last Updated: April 23, 2026</p>
            </header>

            <section className="policy-card" aria-label="Terms of Use">
              <nav className="policy-toc" aria-label="On this page">
                <div className="policy-toc-title">On this page</div>
                <ul className="policy-toc-list">
                  <li>
                    <a className="policy-toc-link" href="#terms-acceptance">
                      1. Acceptance of Terms
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#terms-about">
                      2. About Choicest Fruit
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#terms-use">
                      3. Use of Website and Services
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#terms-programs">
                      4. Programs and Participation
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#terms-training">
                      5. Training Programs and Disclaimers
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#terms-ip">
                      6. Intellectual Property
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#terms-user-content">
                      7. User Content
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#terms-third-party">
                      8. Third-Party Platforms and Links
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#terms-privacy">
                      9. Privacy
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#terms-liability">
                      10. Limitation of Liability
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#terms-changes">
                      11. Changes to Terms
                    </a>
                  </li>
                  <li>
                    <a className="policy-toc-link" href="#terms-contact">
                      12. Contact Information
                    </a>
                  </li>
                </ul>
              </nav>

              <h2 id="terms-acceptance" className="policy-section-title">1. Acceptance of Terms</h2>
              <p className="policy-text">
                By accessing or using the Choicest Fruit® website, programs, services, or platforms
                (including Favrhood), you agree to be bound by these Terms of Use. If you do not agree, please
                do not use our website or services.
              </p>

              <div className="policy-divider" />

              <h2 id="terms-about" className="policy-section-title">2. About Choicest Fruit</h2>
              <p className="policy-text">
                Choicest Fruit®, LLC provides technology education programs, community initiatives, consulting
                services, and platforms designed to support human-centered innovation and community
                development.
              </p>

              <div className="policy-divider" />

              <h2 id="terms-use" className="policy-section-title">3. Use of Website and Services</h2>
              <p className="policy-text">
                You agree to use our website and services only for lawful purposes and in a way that does not:
              </p>
              <ul className="policy-list">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe on the rights of others</li>
                <li>Disrupt or interfere with the operation of our website or programs</li>
              </ul>
              <p className="policy-text">
                We reserve the right to restrict or terminate access if these terms are violated.
              </p>

              <div className="policy-divider" />

              <h2 id="terms-programs" className="policy-section-title">4. Programs and Participation</h2>
              <p className="policy-text">
                Participation in programs (including workshops, internships, and training programs) is subject
                to:
              </p>
              <ul className="policy-list">
                <li>Availability and eligibility requirements</li>
                <li>Completion of any required application or registration</li>
                <li>Adherence to program guidelines and expectations</li>
              </ul>
              <p className="policy-text">
                Choicest Fruit reserves the right to modify, postpone, or cancel programs at any time.
              </p>

              <div className="policy-divider" />

              <h2 id="terms-training" className="policy-section-title">5. Training Programs and Disclaimers</h2>
              <p className="policy-text">
                Choicest Fruit offers a range of learning experiences, including structured training programs
                and community-based workshops.
              </p>
              <ul className="policy-list">
                <li>
                  Certain programs may be developed in alignment with workforce standards or pending review by
                  regulatory bodies such as the Texas Workforce Commission.
                </li>
                <li>
                  Other offerings are workshops, pilot programs, or informal learning experiences and are not
                  part of state-regulated training programs.
                </li>
              </ul>
              <p className="policy-text">
                We make reasonable efforts to accurately describe our programs, but participation does not
                guarantee certification, employment, or specific outcomes.
              </p>

              <div className="policy-divider" />

              <h2 id="terms-ip" className="policy-section-title">6. Intellectual Property</h2>
              <p className="policy-text">
                All content on this website—including text, graphics, logos, and materials—is the property of
                Choicest Fruit®, LLC unless otherwise stated.
              </p>
              <p className="policy-text">
                You may not reproduce, distribute, or use our content without permission, except for personal
                or educational use.
              </p>
              <p className="policy-text">
                Participants may retain rights to their own original work, but by participating in our
                programs, you grant Choicest Fruit permission to showcase projects for educational, promotional,
                or impact purposes (unless otherwise requested).
              </p>

              <div className="policy-divider" />

              <h2 id="terms-user-content" className="policy-section-title">7. User Content</h2>
              <p className="policy-text">
                If you submit content (such as applications, projects, feedback, or posts):
              </p>
              <ul className="policy-list">
                <li>
                  You confirm that the content is your own or that you have permission to share it
                </li>
                <li>You agree not to submit harmful, unlawful, or inappropriate material</li>
              </ul>
              <p className="policy-text">
                We reserve the right to remove content that violates these terms.
              </p>

              <div className="policy-divider" />

              <h2 id="terms-third-party" className="policy-section-title">8. Third-Party Platforms and Links</h2>
              <p className="policy-text">
                Our website and services may reference or link to third-party platforms, including Favrhood or
                partner organizations.
              </p>
              <p className="policy-text">
                We are not responsible for the content, policies, or practices of third-party websites or
                services.
              </p>

              <div className="policy-divider" />

              <h2 id="terms-privacy" className="policy-section-title">9. Privacy</h2>
              <p className="policy-text">
                Your use of our website is also governed by our Privacy Policy. Please review it to understand
                how we collect and use your information.
              </p>
              <p className="policy-text">
                <Link className="policy-link" to="/policies/privacy">
                  View the Privacy Policy
                </Link>
                .
              </p>

              <div className="policy-divider" />

              <h2 id="terms-liability" className="policy-section-title">10. Limitation of Liability</h2>
              <p className="policy-text">Choicest Fruit®, LLC is not liable for:</p>
              <ul className="policy-list">
                <li>Any indirect, incidental, or consequential damages</li>
                <li>Loss of data, opportunities, or outcomes related to participation</li>
              </ul>
              <p className="policy-text">
                All services and programs are provided &ldquo;as is&rdquo; without guarantees of specific results.
              </p>

              <div className="policy-divider" />

              <h2 id="terms-changes" className="policy-section-title">11. Changes to Terms</h2>
              <p className="policy-text">
                We may update these Terms of Use at any time. Changes will be posted on this page with an
                updated effective date.
              </p>
              <p className="policy-text">
                Continued use of our website or services after updates constitutes acceptance of the revised
                terms.
              </p>

              <div className="policy-divider" />

              <h2 id="terms-contact" className="policy-section-title">12. Contact Information</h2>
              <p className="policy-text">If you have questions about these Terms, please contact us:</p>
              <address className="policy-address">
                <div className="policy-address-title">Choicest Fruit®, LLC</div>
                <div>
                  Email:{" "}
                  <a className="policy-link" href="mailto:info@choicestfruit.com">
                    info@choicestfruit.com
                  </a>
                </div>
                <div>Location: Austin, Texas</div>
              </address>
            </section>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default TermsOfUse;
